module.exports = __webpack_public_path__ + "placeholder.468adc39d481f743216270e69b9570a9.png";